import router from './router';
import store from './store';

export { router, store };



// WEBPACK FOOTER //
// ./src/app/video-courses/index.js